const productQuantityOptionsWrapper = document.querySelector('.wz-quantity-bundle-block');
const wizionBundleAppObserver = new MutationObserver(() => {
  if (productQuantityOptionsWrapper.querySelector('.bdl-table-main')) {
    // A tabela foi inserida
    document.querySelector(".product-badges").classList.add("has-progressive-discount-app")

    wizionBundleAppObserver.disconnect(); // Desconecta o observer após a primeira execução
  }
});

wizionBundleAppObserver.observe(productQuantityOptionsWrapper, { childList: true });
